import { render, staticRenderFns } from "./OrderDetailSummary.vue?vue&type=template&id=618a8b4a&scoped=true&"
import script from "./OrderDetailSummary.vue?vue&type=script&lang=js&"
export * from "./OrderDetailSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailSummary.vue?vue&type=style&index=0&id=618a8b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a8b4a",
  null
  
)

export default component.exports